import Mutations from '../../odata/mutations';

export default { ...new Mutations('exchangeRate'), ...new Mutations('exchangeRates') };
